import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import React from "react";
import { AgeConditionalForm } from "../conditionals/AgeConditionalForm";
import { AverageTicketConditionalForm } from "../conditionals/AverageTicketConditionalForm";
import { BirthdayConditionalForm } from "../conditionals/BirthdayConditionalForm";
import { ConsumedProductsConditionalForm } from "../conditionals/ConsumedProductsConditionalForm";
import { ConsumptionMomentsConditionalForm } from "../conditionals/ConsumptionMomentsConditionalForm";
import { DayOfMonthConditionalForm } from "../conditionals/DayOfMonthConditionalForm";
import { DayOfWeekConditionalForm } from "../conditionals/DayOfWeekConditionalForm";
import { DaysWithoutConversionConditionalForm } from "../conditionals/DaysWithoutConversionConditionalForm";
import { LastConversionConditionalForm } from "../conditionals/LastConversionConditionalForm";
import { OrderCountConditionalForm } from "../conditionals/OrderCountConditionalForm";
import { OriginConditionalForm } from "../conditionals/OriginConditionalForm";
import { RegionConditionalForm } from "../conditionals/RegionConditionalForm";
import { SpecificClimateConditionalForm } from "../conditionals/SpecificClimateConditionalForm";
import { SpecificDayConditionalForm } from "../conditionals/SpecificDayConditionalForm";
import { TotalSpendConditionalForm } from "../conditionals/TotalSpendConditionalForm";
import { RegisterTimeFilterForm } from "../filters/RegisterTimeFilterForm";

export class ConditionalGroupForm extends React.Component {
  state = {
    selectedConditional: null,
  };

  componentDidMount() {
    const { node } = this.props;
    this.setState({
      selectedConditional: node.data?.conditionals?.find((f) => f.selected),
    });
  }

  componentDidUpdate(prevProps) {
    const { visible, node } = this.props;
    if (!prevProps.visible && visible) {
      this.setState({
        selectedConditional: node.data?.conditionals?.find((f) => f.selected),
      });
    }
  }

  onChangeFilter(conditional) {
    const { node, onChange } = this.props;

    for (const f of node.data?.conditionals) {
      if (f.selected) {
        f.data = conditional.data;
      }
    }
    onChange && onChange(node);
    this.setState({ selectedConditional: conditional });
  }

  saveGroup(conditional) {
    const { node, onSave } = this.props;

    for (const f of node.data?.conditionals) {
      if (f.selected) {
        f.data = conditional.data;
      }
    }
    onSave && onSave(node);
  }

  render() {
    const { visible, onClose } = this.props;
    const { selectedConditional } = this.state;

    const props = {
      title: selectedConditional?.type && BoxTitles[selectedConditional.type],
      visible: visible,
      onClose: onClose,
      node: selectedConditional,
      onChange: (n) => this.onChangeFilter(n),
      onSave: (n) => this.saveGroup(n),
    };

    switch (selectedConditional?.type) {
      case BoxTypes.DayOfWeekConditional:
        return <DayOfWeekConditionalForm {...props} />;
      case BoxTypes.DayOfMonthConditional:
        return <DayOfMonthConditionalForm {...props} />;
      case BoxTypes.SpecificDayConditional:
        return <SpecificDayConditionalForm {...props} />;
      case BoxTypes.SpecificClimateConditional:
        return <SpecificClimateConditionalForm {...props} />;
      case BoxTypes.AverageTicketConditional:
        return <AverageTicketConditionalForm {...props} />;
      case BoxTypes.OrderCountConditional:
        return <OrderCountConditionalForm {...props} />;
      case BoxTypes.TotalSpendConditional:
        return <TotalSpendConditionalForm {...props} />;
      case BoxTypes.AgeConditional:
        return <AgeConditionalForm {...props} />;
      case BoxTypes.LastConversionConditional:
        return <LastConversionConditionalForm {...props} />;
      case BoxTypes.BirthdayConditional:
        return <BirthdayConditionalForm {...props} />;
      case BoxTypes.RegionConditional:
        return <RegionConditionalForm {...props} />;
      case BoxTypes.RegisterTimeConditional:
        return <RegisterTimeFilterForm {...props} />;
      case BoxTypes.ClimateProfileConditional:
        return null;
      case BoxTypes.ConsumedProductsConditional:
        return <ConsumedProductsConditionalForm {...props} />;
      case BoxTypes.ConsumptionMomentsConditional:
        return <ConsumptionMomentsConditionalForm {...props} />;
      case BoxTypes.OriginConditional:
        return <OriginConditionalForm {...props} />;
      case BoxTypes.DaysWithoutConversionConditional:
        return <DaysWithoutConversionConditionalForm {...props} />;
      default:
        return null;
    }
  }
}
